import { useState } from 'react';
import { useEffectOnce } from 'react-use';
import home from '~/assets/icons/home.svg';
import transfer from '~/assets/icons/transfer.svg';
import { playSound, Sound } from '~/assets/sounds';
import { CurrencyIcon } from '~/components/collections';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { rage, useObservable } from '~/rage';
import { Currency } from '~/shared';
import { BankStages } from '../../models/Bank';
import { setActiveBankState, useLayoutDispatch } from '../../redux';
import { AppBankCards } from '../AppBankCards';
import {
	StyledButton,
	StyledButtonContainer,
	StyledButtonsContainer,
	StyledCardsContainer,
	StyledExpensesContainer,
	StyledHead,
	StyledInfoContainer,
	StyledInfoValue,
	StyledUserPic,
} from './AppBankMain.styled';

let cachedBankMainHasHouses: boolean | null = null;

const AppBankMain = () => {
	const dispatch = useLayoutDispatch();
	const stats = useObservable(rage.bank.getBankStats());
	const rubleIcon = useWalletIcon(Currency.Ruble, true);
	const [hasHouses, setHasHouses] = useState<boolean>(
		() => cachedBankMainHasHouses ?? false,
	);

	useEffectOnce(() => {
		rage.houses
			.getOwnedHousesIds()
			.then((ids) => {
				const next = ids.length > 0;
				cachedBankMainHasHouses = next;
				setHasHouses(next);
			})
			.catch((err) => rage.notifications.showException(err));
	});

	return (
		<div>
			<StyledHead>
				<Text>Главная</Text>
				<StyledUserPic />
			</StyledHead>
			<StyledInfoContainer>
				<StyledExpensesContainer>
					<Text>Траты за месяц</Text>
					<StyledInfoValue>
						<CurrencyIcon icon={rubleIcon} size="sm" />
						<Text>{stats.spent.toLocaleString('ru-RU')}</Text>
					</StyledInfoValue>
				</StyledExpensesContainer>
				<StyledExpensesContainer>
					<Text>Доходы за месяц</Text>
					<StyledInfoValue>
						<CurrencyIcon icon={rubleIcon} size="sm" />
						<Text>{stats.earned.toLocaleString('ru-RU')}</Text>
					</StyledInfoValue>
				</StyledExpensesContainer>
				{/* <StyledFinesContainer
					onClick={() => dispatch(setActiveBankState(BankStages.Fines))}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				>
					<StyledFinesArrow />
					<Text>Штрафы</Text>
					<StyledInfoValue>
						<CurrencyIcon icon={rubleIcon} size="sm" />
						<Text>12 345</Text>
					</StyledInfoValue>
				</StyledFinesContainer> */}
			</StyledInfoContainer>
			<StyledCardsContainer>
				<AppBankCards />
			</StyledCardsContainer>
			<StyledButtonsContainer>
				{hasHouses && (
					<StyledButtonContainer
						onClick={() => {
							dispatch(setActiveBankState(BankStages.TAXES));
							playSound(Sound.ClickButton);
						}}
						onMouseEnter={() => playSound(Sound.LinkCursor)}
					>
						<StyledButton>
							<img src={home} />
						</StyledButton>
						<Text>Налоги</Text>
					</StyledButtonContainer>
				)}
				<StyledButtonContainer
					onClick={() => {
						dispatch(setActiveBankState(BankStages.TRANSFER));
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				>
					<StyledButton>
						<img src={transfer} />
					</StyledButton>
					<Text>Переводы</Text>
				</StyledButtonContainer>
			</StyledButtonsContainer>
		</div>
	);
};

export { AppBankMain };
